/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import BoardCollabInviteCellContainer from 'app/common/react/components/BoardCollab/BoardCollabInviteCellContainer';
import BoardInvites from 'app/common/react/components/BoardEdit/BoardInvites/BoardInvites';
import ContactCell from 'app/common/react/components/BoardCollab/ContactCell';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import SocialTypeahead from 'app/common/react/components/BoardEdit/SocialTypeahead/SocialTypeahead';
import withResource from 'app/common/lib/react/withResource';
import withViewer from 'app/common/lib/react/withViewer';
import { Button } from 'gestalt';
import { compose } from 'redux';
import { inviteEmails } from 'app/common/redux/actions/board/collab';
import { isEmailAddress } from 'app/common/lib/StringUtil';

const inviteType = {
  access: PropTypes.arrayOf(PropTypes.oneOf(['approve', 'delete'])).isRequired,
  invited_user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired,
  }),
  invited_by_user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired,
  }),
  status: PropTypes.oneOf(['new', 'accepted', 'contact_request_not_approved', 'pending_approval']),
  type: PropTypes.oneOf(['collaboratorinvite']).isRequired,
};

class BoardInviteForm extends Component {
  static propTypes = {
    boardId: PropTypes.string.isRequired,
    boardOwner: PropTypes.shape({
      full_name: PropTypes.string,
      id: PropTypes.string,
      image_key: PropTypes.string,
      image_medium_url: PropTypes.string,
    }).isRequired,
    invites: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape(inviteType)),
      fetchMore: PropTypes.func.isRequired,
      isAtEnd: PropTypes.bool.isRequired,
      isFetching: PropTypes.bool.isRequired,
      isLoaded: PropTypes.bool.isRequired,
      refreshData: PropTypes.func.isRequired,
    }),
    onBoardLeave: PropTypes.func.isRequired,
    viewer: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  };

  state = {
    isInviting: false,
    scrollContainer: undefined,
    value: '',
  };

  handleInviteClick = () => {
    const {
      boardId,
      invites: { refreshData: refreshInvites },
    } = this.props;
    const email = this.state.value;
    if (!isEmailAddress(email)) {
      return;
    }
    this.setState({ isInviting: true });
    inviteEmails(boardId, [email])
      .then(refreshInvites)
      .finally(() => {
        this.setState({
          isInviting: false,
          value: '',
        });
      });
  };

  handleInviteItemClick = (promise) => {
    const {
      invites: { refreshData: refreshInvites },
    } = this.props;
    this.setState({ isInviting: true });
    promise.then(refreshInvites).finally(() => {
      this.setState({
        isInviting: false,
        value: '',
      });
    });
  };

  handleInviterScrollContainer = (ref) => {
    if (!this.state.scrollContainer) {
      this.setState({ scrollContainer: ref });
    }
  };

  currentUserIsOwner = () => this.props.boardOwner.id === this.props.viewer.id;

  renderInvite(invite, onBoardLeave, onInviteDidUpdate) {
    const boardInviteProps = {
      invite,
      onBoardLeave,
      onInviteDidUpdate,
      useGestaltModal: true,
      isDim: false,
    };
    return <BoardCollabInviteCellContainer {...boardInviteProps} />;
  }

  render() {
    const { boardId, boardOwner, invites, onBoardLeave } = this.props;
    const { data: invitesData, fetchMore, isAtEnd, isFetching, isLoaded, refreshData } = invites;

    const { full_name: name, image_medium_url: imageUrl, username } = boardOwner;

    return (
      <div>
        <div className="BoardInviteForm collaboratorInvitesNoMargin">
          <div className="inviteWrapper">
            <div className="fillWidth" style={{ position: 'relative' }}>
              <SocialTypeahead
                boardId={boardId}
                onChange={(value) => this.setState({ value })}
                onInviteItemClick={this.handleInviteItemClick}
                value={this.state.value}
              />
            </div>
            <Button
              inline
              onClick={this.handleInviteClick}
              text={i18n._('Invite', 'ask to join')}
            />
          </div>
        </div>
        <div className="boardEditCollaborators" ref={this.handleInviterScrollContainer}>
          <ContactCell
            imageUrl={imageUrl}
            linkURL={`/${username}/`}
            name={name}
            subtitle={username}
            title={name}
          />
          {isLoaded ? (
            <BoardInvites
              boardId={boardId}
              fetchMore={fetchMore}
              invites={invitesData || []}
              isAtEnd={isAtEnd}
              isFetching={isFetching}
              onBoardLeave={onBoardLeave}
              refreshData={refreshData}
              renderInvite={this.renderInvite}
              scrollContainer={this.state.scrollContainer}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default compose(
  withResource(
    {
      name: 'BoardInvitesResource',
      options: (props) => ({
        board_id: props.boardId,
        sort: 'viewer_first',
        field_set_key: 'boardEdit',
        status_filters: 'new,accepted,contact_request_not_approved,pending_approval',
        include_inactive: true,
      }),
      key: 'invites',
    },
    { allowStale: false },
  ),
  withViewer,
)(BoardInviteForm);
